import React, { useMemo } from 'react';
import { X } from 'lucide-react';
import { ColumnFilterPopover } from '../ColumnFilterPopover';

const FIELDS = [
  { key: 'pm', label: 'PM', get: (e) => [e.pm] },
  { key: 'trainer', label: 'Trainer', get: (e) => e.trainers || [] },
  { key: 'client', label: 'Client', get: (e) => [e.client] },
];

export const EMPTY_FILTERS = { pm: new Set(), trainer: new Set(), client: new Set() };

export const applyCalendarFilters = (events, filters) => events.filter((e) =>
  FIELDS.every((f) => filters[f.key].size === 0 || f.get(e).some((v) => filters[f.key].has(v))));

export const CalendarFilters = ({ events, filters, onChange, testId }) => {
  const options = useMemo(() => Object.fromEntries(FIELDS.map((f) => {
    const vals = [...new Set(events.flatMap(f.get).filter((v) => v && v !== '—' && v !== 'Unknown'))].sort();
    return [f.key, vals.map((v) => ({ value: v, label: v }))];
  })), [events]);
  const active = Object.values(filters).some((s) => s.size > 0);

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-filters`}>
      {FIELDS.filter((f) => options[f.key].length > 0 || filters[f.key].size > 0).map((f) => (
        <div key={f.key} className={`text-xs px-2.5 py-1.5 rounded-full border transition-colors ${filters[f.key].size ? 'border-primary/40 bg-primary/5' : 'border-border hover:bg-muted/60'}`}>
          <ColumnFilterPopover label={f.label} options={options[f.key]} selected={filters[f.key]}
            onChange={(s) => onChange({ ...filters, [f.key]: s })} testId={`${testId}-filter-${f.key}`} />
        </div>
      ))}
      {active && (
        <button type="button" onClick={() => onChange(EMPTY_FILTERS)} className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground px-2 py-1.5"
          data-testid={`${testId}-clear-filters`}>
          <X className="w-3 h-3" /> Clear filters
        </button>
      )}
    </div>
  );
};
